import { render, staticRenderFns } from "./TrainingMetricsChart.vue?vue&type=template&id=33cb9fc3&scoped=true"
import script from "./TrainingMetricsChart.vue?vue&type=script&lang=js"
export * from "./TrainingMetricsChart.vue?vue&type=script&lang=js"
import style0 from "./TrainingMetricsChart.vue?vue&type=style&index=0&id=33cb9fc3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33cb9fc3",
  null
  
)

export default component.exports